<template>
    <div class="home">
        <div class="home-page-top">
            <AppHeader></AppHeader>
            <el-row class="title-row" type="flex" justify="center" align="middle">
                <el-col :span="24">
                    <div class="title-container">
                        <span>گروه</span>
                        <span> علمی آموزشی </span>
                        <span>اوج</span>
                    </div>
                </el-col>
            </el-row>
        </div>

        <el-row type="flex" justify="center" class="home-page-slogan-row">
            <el-col :span="24">
                <div class="home-page-slogan-title">
                    ارائه دهنده راهکار های برتر آموزشی
                </div>
                <el-divider></el-divider>
                <div class="home-page-slogan-desc">
                    پیشرو در ارائه‌ی خدمات آموزشی در راستای ارتقای سطح عدالت آموزشی کشور
                </div>
            </el-col>
        </el-row>

        <el-row type="flex" justify="center" :gutter="15" class="home-page-boxes-row">
            <el-col :xs="{span: 22, push: 1}" :sm="6" :md="6" :lg="5" :xl="4" >
                <div class="home-page-box teachers-box">
                    <img src="../assets/images/TeacherBox.png" class="home-page-box-image"/>
                    <div class="home-page-box-text">
                        اساتید مجرب
                    </div>
                </div>
            </el-col>
            <el-col :xs="{span: 22, push: 1}" :sm="6" :md="6" :lg="5" :xl="4" >
                <div class="home-page-box student-panel-box">
                    <img src="../assets/images/StudentPanelBox.png" class="home-page-box-image"/>
                    <div class="home-page-box-text">
                        پنل دانش‌آموزان
                    </div>
                </div>
            </el-col>
            <el-col :xs="{span: 22, push: 1}" :sm="6" :md="6" :lg="5" :xl="4" >
                <div class="home-page-box guide-box">
                    <img src="../assets/images/GuideBox.png" class="home-page-box-image"/>
                    <div class="home-page-box-text">
                        مشاوره های کاربردی
                    </div>
                </div>
            </el-col>
        </el-row>

        <el-row type="flex" justify="center" :gutter="15" class="home-page-stats-overview-row" ref="statsRow">
            <el-col :xs="{span: 22, push: 1}" :sm="6" :md="6" :lg="5" :xl="4" >
                <div class="home-page-stats-overview-container">
                    <el-progress
                        type="circle"
                        color="#E53935"
                        :stroke-width="10"
                        :show-text="false"
                        :percentage="studentsCount">
                    </el-progress>
                    <div class="stat-number">+100</div>
                </div>
                <div class="home-page-stats-overview-desc">دانش ‌آموز</div>
            </el-col>
            <el-col :xs="{span: 22, push: 1}" :sm="6" :md="6" :lg="5" :xl="4" >
                <div class="home-page-stats-overview-container">
                    <el-progress
                        type="circle"
                        color="#4886FF"
                        :stroke-width="10"
                        :show-text="false"
                        :percentage="teachersCount">
                    </el-progress>
                    <div class="stat-number">+20</div>
                </div>
                <div class="home-page-stats-overview-desc">استاد</div>
            </el-col>
            <el-col :xs="{span: 22, push: 1}" :sm="6" :md="6" :lg="5" :xl="4" >
                <div class="home-page-stats-overview-container">
                    <el-progress
                        type="circle"
                        color="#FF7F45"
                        :stroke-width="10"
                        :show-text="false"
                        :percentage="classesCount">
                    </el-progress>
                    <div class="stat-number">10</div>
                </div>
                <div class="home-page-stats-overview-desc">کلاس</div>
            </el-col>
        </el-row>
        <AppFooter></AppFooter>
    </div>
</template>

<script>
    /* eslint-disable */
    // @ is an alias to /src
    import AppHeader from './AppHeader';
    import AppFooter from './AppFooter';
    export default {
        name: 'home',
        components: {
            AppFooter,
            AppHeader
        },
        data() {
            return {
                studentsPercentage: 60,
                teachersPercentage: 75,
                classesPercentage: 40,
                studentsCount: 0,
                teachersCount: 0,
                classesCount: 0,
            }
        },
        methods: {
            count(end) {
                for (let i = 0; i <= end; i++) {
                    let timeoutRef = setTimeout(() => {
                        end += 1;
                    }, 10);
                    timeoutRef.clear();
                }
            }
        },
        mounted() {
            // let intervalRef = setInterval(() => {
                // if (window.pageYOffset + window.innerHeight >= this.$refs.statsRow.$el.offsetTop + this.$refs.statsRow.$el.scrollHeight) {
                    // this.studentsCount += (this.studentsCount < this.studentsPercentage)? 1: 0;
                    // this.teachersCount += (this.teachersCount < this.teachersPercentage)? 1: 0;
                    // this.classesCount += (this.classesCount < this.classesPercentage)? 1: 0;

                    // this.studentsCount = this.studentsPercentage;
                    // this.teachersCount = this.teachersPercentage;
                    // this.classesCount = this.classesPercentage;

                    // if (this.studentsCount === this.studentsPercentage &&
                    //     this.teachersCount === this.teachersPercentage &&
                    //     this.classesCount === this.classesPercentage) {
                    //     clearInterval(intervalRef);
                    // }
                // }
            // }, 500);
        },
        destroyed() {

        },
        metaInfo: {
            meta: [
                {name: 'description', content: 'اوج، متخصص در تیزهوشان و نمونه دولتی.'},
                // OpenGraph data (Most widely used)
                {property: 'og:title', content: 'اوج'},
                {property: 'og:site_name', content: 'گروه علمی آموزشی اوج'},
                // The list of types is available here: http://ogp.me/#types
                {property: 'og:type', content: 'website'},
                // Should the the same as your canonical link, see below.
                {property: 'og:url', content: 'https://owjeducation.ir/'},
                // {property: 'og:image', content: 'https://www.my-site.com/my-special-image.jpg'},
                // Often the same as your meta description, but not always.
                {property: 'og:description', content: 'اوج، متخصص در تیزهوشان و نمونه دولتی.'},


                // Google / Schema.org markup:
                {itemprop: 'name', content: 'گروه علمی آموزشی اوج'},
                // {itemprop: 'description', content: this.writingAbstract},
                // {itemprop: 'image', content: 'https://www.my-site.com/my-special-image.jpg'}
            ]
        }
    }
</script>

<style lang="scss" scoped>
    .home-page-top {
        background-image: url('../assets/images/HomePageSplash.jpg');
        background-size: cover;
        background-position: center center;
        height: 97vh;

        .title-row {
            margin-top: 15%;

            .title-container {
                font-size: 85px;
                color: white;
            }
        }

    }

    .home-page-slogan-row {
        margin: 0 !important;
        padding: 30px;

        .home-page-slogan-title {
            font-size: 30px;
            color: #333333;
        }
        .el-divider {
            width: 60%;
            margin: 15px auto;
        }
        .home-page-slogan-desc {
            font-size: 16px;
            color: #6A6C6D;
        }
    }

    .home-page-boxes-row {
        margin: 0 !important;
        padding: 30px 0;
        @media only screen and (max-width: 767px) {
            flex-direction: column-reverse;
        }

        .el-col {
            @media only screen and (max-width: 767px) {
                margin-bottom: 20px;
            }

            .home-page-box {
                padding: 25px 0;
                border-radius: 5px;

                &.teachers-box {
                    background-color: rgba(72, 134, 255, 1);
                }
                &.student-panel-box {
                    background-color: rgba(181, 213, 106, 1);
                }
                &.guide-box {
                    background-color: rgba(255, 111, 111, 1);
                }

                .home-page-box-text {
                    font-size: 20px;
                    color: white;
                }
            }
        }
    }

    .home-page-stats-overview-row {
        margin: 0 !important;
        padding: 50px 0;
        background-image: linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url('../assets/images/StatsOverviewBG.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center bottom;
        @media only screen and (max-width: 767px) {
            background-size: 500%;
            flex-direction: column-reverse;
        }

        .el-col {
            @media only screen and (max-width: 767px) {
                margin-bottom: 70px;
            }

            .home-page-stats-overview-desc {
                font-size: 20px;
                color: white;
            }

            .home-page-stats-overview-container {
                position: relative;

                .el-progress {
                    &::v-deep svg {
                        height: unset;
                    }
                }

                .stat-number {
                    font-size: 30px;
                    position: absolute;
                    width: 100%;
                    top: 32%;
                    color: white;
                }
            }
        }
    }
</style>
